import React from 'react';
import styled from 'styled-components';
import { ICON_SIZE } from '../../constants';
import SvgIcon from '../../SvgIcon';
import { BUTTON_ICON_HORIZONTAL_MARGIN } from '../constants';
import { Small as SmallTypographySize } from '../../Typography/constants/small.size';
import { ExtraSmall as ExtraSmallTypographySize } from '../../Typography/constants/extra-small.size';
import { baseTextStyle } from '../../Typography/style/base';
import { absoluteCenteredStyle } from '../../tokens/centered';
import InfoWithIconsSimple from '../../Info/InfoWithIcons/InfoWithIconsSimple';
import { lineHeight } from '../../style/line-height';
import { fontSize } from '../../style/font-size';
const ICON_TOP_POSITION = {
  small: 0,
  medium: {
    xs: 0,
    lg: -1
  }
};
const FONT_SIZE = {
  medium: SmallTypographySize.fontSize,
  small: ExtraSmallTypographySize.fontSize
};
const LINE_HEIGHT = {
  medium: SmallTypographySize.lineHeight,
  small: ExtraSmallTypographySize.lineHeight
};
const StyledIcon = styled(SvgIcon)`
  position: relative;
  & > * {
    ${absoluteCenteredStyle}
  }
`;
const StyledWrapper = styled.span`
  flex-direction: column;
  display: flex;
  flex-grow: 1;
`;
const StyledTitle = styled.span`
  display: inline-block;
  text-align: center;
`;
const StyledSubTitle = styled.span`
  display: inline-block;
  text-align: center;
  ${baseTextStyle}
  ${({
  size: value = 'medium'
}) => fontSize(FONT_SIZE[value] || FONT_SIZE.medium)}
  ${({
  size: value = 'medium'
}) => lineHeight(LINE_HEIGHT[value] || LINE_HEIGHT.medium)}
`;
const ButtonContent = ({
  vertical = false,
  noIconWrapper = false,
  noChildren = false,
  icon,
  iconSize = ICON_SIZE,
  iconRightSize = ICON_SIZE,
  iconTopPosition,
  iconRightTopPosition,
  iconRight,
  iconMargin = BUTTON_ICON_HORIZONTAL_MARGIN,
  iconRightMargin = BUTTON_ICON_HORIZONTAL_MARGIN,
  title,
  subTitle,
  size = 'medium',
  content
}) => /*#__PURE__*/React.createElement(InfoWithIconsSimple, {
  icon: !icon ? null : noIconWrapper ? icon : /*#__PURE__*/React.createElement(StyledIcon, {
    size: iconSize,
    color: null
  }, icon),
  iconRight: !iconRight ? null : noIconWrapper ? iconRight : /*#__PURE__*/React.createElement(StyledIcon, {
    size: iconRightSize,
    color: null
  }, iconRight),
  iconMargin: iconMargin,
  iconRightMargin: iconRightMargin,
  iconTopPosition: iconTopPosition ?? (ICON_TOP_POSITION[size] || ICON_TOP_POSITION.medium),
  iconRightTopPosition: iconRightTopPosition ?? (ICON_TOP_POSITION[size] || ICON_TOP_POSITION.medium),
  vertical: vertical,
  noChildren: noChildren
}, title || subTitle ? /*#__PURE__*/React.createElement(StyledWrapper, null, (title || content) && (!subTitle ? title || content : /*#__PURE__*/React.createElement(StyledTitle, {
  size: size
}, title || content)), subTitle && /*#__PURE__*/React.createElement(StyledSubTitle, {
  size: size
}, subTitle)) : content);
export default ButtonContent;